var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"content"},[_c('Username',{attrs:{"user":_vm.message.from}}),_vm._v("\n\tis now known as\n\t"),_c('Username',{attrs:{"user":{nick: _vm.message.new_nick, mode: _vm.message.from.mode}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }